import { Component } from '@angular/core';
import { CaptureHistoryItemTypeBaseComponent } from '../capture-history-item-type-base/capture-history-item-type-base.component';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-capture-history-item-type-consult-note-submitted',
    templateUrl: './capture-history-item-type-consult-note-submitted.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent, RouterLink]
})
export class CaptureHistoryItemTypeConsultNoteSubmittedComponent extends CaptureHistoryItemTypeBaseComponent {
  get title() {
    return 'Consult Note Submitted';
  }

  get consultNoteId() {
    return this.captureHistoryItem.relatedRecord.id;
  }
}
